module.exports = __webpack_public_path__ + "public/SiteIcons/moreReceipt.svg?b04c9c19";